import { CommonModule } from '@angular/common';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from 'ngx-quill';

const _c0 = function (a0) { return { height: a0 }; };
function WysiwygComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n        ");
    ɵngcc0.ɵɵelementStart(2, "span", 2);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵelementStart(4, "quill-editor", 3, 4);
    ɵngcc0.ɵɵlistener("onBlur", function WysiwygComponent_ng_container_0_ng_container_2_Template_quill_editor_onBlur_4_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.blur.emit(); })("onFocus", function WysiwygComponent_ng_container_0_ng_container_2_Template_quill_editor_onFocus_4_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.focus.emit(); })("onEditorCreated", function WysiwygComponent_ng_container_0_ng_container_2_Template_quill_editor_onEditorCreated_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.quillEditor = $event; })("onContentChanged", function WysiwygComponent_ng_container_0_ng_container_2_Template_quill_editor_onContentChanged_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.handleContentChanged($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, "\n    ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r1.parentForm);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵstyleMap(ctx_r1.config && ctx_r1.config.height ? ɵngcc0.ɵɵpureFunction1(6, _c0, ctx_r1.config.height + "px") : null);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r1.controlName)("modules", ctx_r1.quillModuleConfig ? ctx_r1.quillModuleConfig : null)("readOnly", ctx_r1.disabled);
} }
function WysiwygComponent_ng_container_0_quill_editor_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "quill-editor", 5, 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function WysiwygComponent_ng_container_0_quill_editor_4_Template_quill_editor_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.value = $event; })("onBlur", function WysiwygComponent_ng_container_0_quill_editor_4_Template_quill_editor_onBlur_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.blur.emit(); })("onFocus", function WysiwygComponent_ng_container_0_quill_editor_4_Template_quill_editor_onFocus_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.focus.emit(); })("onEditorCreated", function WysiwygComponent_ng_container_0_quill_editor_4_Template_quill_editor_onEditorCreated_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.quillEditor = $event; })("onContentChanged", function WysiwygComponent_ng_container_0_quill_editor_4_Template_quill_editor_onContentChanged_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.handleContentChanged($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleMap(ctx_r2.config && ctx_r2.config.height ? ɵngcc0.ɵɵpureFunction1(5, _c0, ctx_r2.config.height + "px") : null);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.value)("modules", ctx_r2.quillModuleConfig ? ctx_r2.quillModuleConfig : null)("readOnly", ctx_r2.disabled);
} }
function WysiwygComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n    ");
    ɵngcc0.ɵɵtemplate(2, WysiwygComponent_ng_container_0_ng_container_2_Template, 8, 8, "ng-container", 0);
    ɵngcc0.ɵɵtext(3, "\n    ");
    ɵngcc0.ɵɵtemplate(4, WysiwygComponent_ng_container_0_quill_editor_4_Template, 2, 7, "quill-editor", 1);
    ɵngcc0.ɵɵtext(5, "\n");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.parentForm && ctx_r0.controlName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r0.parentForm && ctx_r0.controlName));
} }
function buildQuillToolbarConfig(toolbarOptions) {
    const moduleConfig = [];
    buildQuillToolbar(moduleConfig, toolbarOptions);
    return moduleConfig;
}
function buildQuillToolbar(moduleConfig, toolbarOptions) {
    toolbarOptions.forEach((option) => {
        if (Array.isArray(option)) {
            const newConfigArray = [];
            buildQuillToolbar(newConfigArray, option);
            moduleConfig.push(newConfigArray);
        }
        else {
            switch (option) {
                case 'bullet-list':
                    moduleConfig.push({ list: 'bullet' });
                    break;
                case 'ordered-list':
                    moduleConfig.push({ list: 'ordered' });
                    break;
                case 'align':
                    moduleConfig.push({ align: [] });
                    break;
                case 'font-size':
                    moduleConfig.push({ size: ['small', false, 'large', 'huge'] });
                    break;
                default:
                    moduleConfig.push(option);
            }
        }
    });
}

class WysiwygComponent {
    constructor() {
        // things got funky when dynamically loading the stylesheet
        // only on initial page load would some odd behavior happen
        // so using readyToShow with a setTimeout to ensure all stylesheets
        // are parsed prior to trying to show the control
        this.readyToShow = false;
        this.parentForm = null;
        this.controlName = null;
        this.disabled = false;
        this.config = {
            toolbar: ['bold', 'italic', 'underline', 'link'],
        };
        this._value = null;
        this.valueChange = new EventEmitter();
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.contentChanged = new EventEmitter();
        this.ready = new EventEmitter();
    }
    set value(value) {
        this._value = value;
        this.valueChange.emit(value);
    }
    get value() {
        return this._value;
    }
    get quillModuleConfig() {
        var _a;
        if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.toolbar) {
            return {
                toolbar: buildQuillToolbarConfig(this.config.toolbar),
            };
        }
        return null;
    }
    ngOnInit() {
        this.ready.emit({
            focus: this.focusMe.bind(this),
        });
        // see explanation of the readyToShow property for why this is in a setTimeout here
        setTimeout(() => {
            this.readyToShow = true;
        }, 0);
    }
    focusMe() {
        if (this.quillEditor) {
            this.quillEditor.focus();
        }
    }
    handleContentChanged(event) {
        const changeEvent = {
            html: event.html,
            text: event.text,
        };
        this.contentChanged.emit(changeEvent);
    }
}
WysiwygComponent.ɵfac = function WysiwygComponent_Factory(t) { return new (t || WysiwygComponent)(); };
WysiwygComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WysiwygComponent, selectors: [["mt-wysiwyg"]], inputs: { parentForm: "parentForm", controlName: "controlName", disabled: "disabled", config: "config", value: "value" }, outputs: { valueChange: "valueChange", blur: "blur", focus: "focus", contentChanged: "contentChanged", ready: "ready" }, decls: 2, vars: 1, consts: [[4, "ngIf"], [3, "ngModel", "modules", "readOnly", "style", "ngModelChange", "onBlur", "onFocus", "onEditorCreated", "onContentChanged", 4, "ngIf"], [3, "formGroup"], [3, "formControlName", "modules", "readOnly", "onBlur", "onFocus", "onEditorCreated", "onContentChanged"], ["inputElement", ""], [3, "ngModel", "modules", "readOnly", "ngModelChange", "onBlur", "onFocus", "onEditorCreated", "onContentChanged"]], template: function WysiwygComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, WysiwygComponent_ng_container_0_Template, 6, 2, "ng-container", 0);
        ɵngcc0.ɵɵtext(1, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.readyToShow);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc3.QuillEditorComponent, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc2.NgModel], encapsulation: 2 });
WysiwygComponent.propDecorators = {
    parentForm: [{ type: Input }],
    controlName: [{ type: Input }],
    disabled: [{ type: Input }],
    config: [{ type: Input }],
    value: [{ type: Input }],
    valueChange: [{ type: Output }],
    blur: [{ type: Output }],
    focus: [{ type: Output }],
    contentChanged: [{ type: Output }],
    ready: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WysiwygComponent, [{
        type: Component,
        args: [{
                selector: 'mt-wysiwyg',
                template: "<ng-container *ngIf=\"readyToShow\">\n    <ng-container *ngIf=\"parentForm && controlName\">\n        <span [formGroup]=\"parentForm\">\n            <quill-editor\n                #inputElement\n                [formControlName]=\"controlName\"\n                [modules]=\"quillModuleConfig ? quillModuleConfig : null\"\n                [readOnly]=\"disabled\"\n                [style]=\"config && config.height ? { height: config.height + 'px' } : null\"\n                (onBlur)=\"blur.emit()\"\n                (onFocus)=\"focus.emit()\"\n                (onEditorCreated)=\"quillEditor = $event\"\n                (onContentChanged)=\"handleContentChanged($event)\"\n            ></quill-editor>\n        </span>\n    </ng-container>\n    <quill-editor\n        #inputElement\n        *ngIf=\"!(parentForm && controlName)\"\n        [(ngModel)]=\"value\"\n        [modules]=\"quillModuleConfig ? quillModuleConfig : null\"\n        [readOnly]=\"disabled\"\n        [style]=\"config && config.height ? { height: config.height + 'px' } : null\"\n        (onBlur)=\"blur.emit()\"\n        (onFocus)=\"focus.emit()\"\n        (onEditorCreated)=\"quillEditor = $event\"\n        (onContentChanged)=\"handleContentChanged($event)\"\n    ></quill-editor>\n</ng-container>\n"
            }]
    }], function () { return []; }, { parentForm: [{
            type: Input
        }], controlName: [{
            type: Input
        }], disabled: [{
            type: Input
        }], config: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], contentChanged: [{
            type: Output
        }], ready: [{
            type: Output
        }], value: [{
            type: Input
        }] }); })();

class WysiwygViewComponent {
    constructor() {
        this.value = null;
    }
}
WysiwygViewComponent.ɵfac = function WysiwygViewComponent_Factory(t) { return new (t || WysiwygViewComponent)(); };
WysiwygViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WysiwygViewComponent, selectors: [["mt-wysiwyg-view"]], inputs: { value: "value" }, decls: 2, vars: 1, consts: [[3, "content"]], template: function WysiwygViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "quill-view", 0);
        ɵngcc0.ɵɵtext(1, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("content", ctx.value);
    } }, directives: [ɵngcc3.QuillViewComponent], encapsulation: 2 });
WysiwygViewComponent.propDecorators = {
    value: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WysiwygViewComponent, [{
        type: Component,
        args: [{
                selector: 'mt-wysiwyg-view',
                template: "<quill-view [content]=\"value\"></quill-view>\n"
            }]
    }], function () { return []; }, { value: [{
            type: Input
        }] }); })();

let initialized = false;
function initialize() {
    if (initialized) {
        return;
    }
    initialized = true;
    // inject the stylesheet request
    let stylesheetLink = document.createElement('link');
    stylesheetLink.href = 'https://cdn.quilljs.com/1.3.6/quill.snow.css';
    stylesheetLink.rel = 'stylesheet';
    let firstLink = document.getElementsByTagName('link')[0];
    firstLink.parentNode.insertBefore(stylesheetLink, firstLink);
}

class WysiwygModule {
    constructor() {
        initialize();
    }
}
WysiwygModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: WysiwygModule });
WysiwygModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function WysiwygModule_Factory(t) { return new (t || WysiwygModule)(); }, imports: [[CommonModule, QuillModule.forRoot(), FormsModule, ReactiveFormsModule]] });
WysiwygModule.ctorParameters = () => [];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(WysiwygModule, { declarations: function () { return [WysiwygComponent, WysiwygViewComponent]; }, imports: function () { return [CommonModule, ɵngcc3.QuillModule, FormsModule, ReactiveFormsModule]; }, exports: function () { return [WysiwygComponent, WysiwygViewComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WysiwygModule, [{
        type: NgModule,
        args: [{
                declarations: [WysiwygComponent, WysiwygViewComponent],
                exports: [WysiwygComponent, WysiwygViewComponent],
                imports: [CommonModule, QuillModule.forRoot(), FormsModule, ReactiveFormsModule]
            }]
    }], function () { return []; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { WysiwygModule, buildQuillToolbarConfig, WysiwygComponent as ɵa, WysiwygViewComponent as ɵb };


//# sourceMappingURL=mt-ng2-wysiwyg-control.js.map